export default {
    role_name : '角色名称',
    role_description: '描述',
    role_member_count: '成员数',
    role_created_time: '创建时间',
    role_operation: '操作',
}